import React from 'react';

const NotFoundComponent = (
  <div>
    404!
  </div>
);

export default NotFoundComponent;
